<template>
  <SlotPanel v-if="updatedPerformance" classes="z-10 !p-0">
    <PerformanceDateTimePicker
      id="publishDatetimePicker"
      :initialDatetime="selectedPerformance?.publish_datetime || null"
      v-model="updatedPerformance.publish_datetime"
      class="px-4 pt-4"
    >
      <template #label>Published Date & Time</template>
      <template #dateTimeLabel="{ hasOccurred, dateTimeStr }">
        <span v-if="hasOccurred">Now Public</span>
        <span v-else>{{ dateTimeStr }}</span>
      </template>
      <template #footer="{ timeFromNow, hasOccurred }">
        <span v-if="hasOccurred">
          People <span class="font-semibold">can</span> see and purchase tickets for this
          performance <span class="font-semibold">from now on.</span>
        </span>
        <span v-else>
          People <span class="font-semibold">will be able</span> to see and purchase tickets for
          this performance <span class="font-semibold">{{ timeFromNow }}.</span>
        </span>
      </template>
    </PerformanceDateTimePicker>

    <hr class="mt-6 mb-5 border-linear-subtle border-1" />

    <PerformanceDateTimePicker
      id="performanceDatetimePicker"
      :initialDatetime="selectedPerformance?.datetime || null"
      v-model="updatedPerformance.datetime"
      class="px-4 pb-5"
    >
      <template #label>Performance Date & Time</template>
      <template #dateTimeLabel="{ hasOccurred, dateTimeStr }">
        <span v-if="hasOccurred">Already Performed</span>
        <span v-else>{{ dateTimeStr }}</span>
      </template>
      <template #footer="{ timeFromNow, hasOccurred, dateTimeStr }">
        <span v-if="hasOccurred">
          This performance <span class="font-semibold">occurred {{ timeFromNow }}.</span> -
          {{ dateTimeStr }}
        </span>
        <span v-else>
          Attendees <span class="font-semibold">will enjoy</span> this performance
          <span class="font-semibold">{{ timeFromNow }}.</span>
        </span>
      </template>
    </PerformanceDateTimePicker>

    <p
      id="datetimeUpdatedWarning"
      v-if="isDatetimeUpdated && performanceReservations.length > 0"
      class="text-alerts-warning px-4 pb-5 leading-5"
    >
      The change of this date will adjust the {{ performanceReservations.length }} existing
      reservations to the new selected date.
    </p>
  </SlotPanel>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import SlotPanel from '@/common/components/organisms/SlotPanel.vue'
import PerformanceDateTimePicker from '@/modules/performance/components/organisms/PerformanceDateTimePicker.vue'
import { usePerformanceReservationStore } from '@/modules/performance/stores/PerformanceReservationStore'
import { usePerformanceUpdateStore } from '@/modules/performance/stores/PerformanceUpdateStore'

const { performanceReservations, selectedPerformance } = storeToRefs(
  usePerformanceReservationStore(),
)
const performanceUpdateStore = usePerformanceUpdateStore()
const { updatedPerformance, isDatetimeUpdated } = storeToRefs(performanceUpdateStore)
</script>
